
import type { PropType } from 'vue/types/options'
import type { AuditItem } from '../../../../models/services/audit'
import { defineComponent } from 'vue'

import { TYPES } from '../../../../config/inversify.types'

import AuditDetails from '../audit-details.component.vue'

export default defineComponent({
  name: 'TaggingServiceAuditDetails',
  components: {
    AuditDetails,
  },
  inject: {
    objectIdService: TYPES.ObjectIdService,
  },
  props: {
    audit: {
      type: Object as PropType<AuditItem>,
      required: true,
    },
    ignoredFields: {
      type: Array as PropType<Array<string>>,
      default: () =>
        AuditDetails.props.ignoredFields
          .default()
          .filter((field: string) => field !== 'filters')
          .concat(['sinks']),
    },
    messages: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getFiltersText(filters: { name: string; values: string[] }): string {
      const filtersText = Object.entries(filters).map(([key, value]: [string, any]) => {
        return `<strong>${key}:</strong> ${Array.isArray(value) ? value.join(', ') : value}`
      })
      return filtersText.join('<br>')
    },
  },
})
